const dateHelper = {}

dateHelper.getLastNMonths = (numberOfMonths) => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  const today = new Date()
  const pastNMonths = []
  for (let i = numberOfMonths - 1; i > 0; i--) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1)
    const month = monthNames[date.getMonth()]
    pastNMonths.push(`${month} ${date.getFullYear()}`)
  }
  pastNMonths.push(`${monthNames[today.getMonth()]} ${today.getFullYear()}`)
  return pastNMonths
}

export default dateHelper
